export default __webpack_public_path__ + "static/media/logo.84053cf9.png";